import '../style.scss';
import { Description, labelColor, labelSize } from 'views/mutual/description';
import {
  LabelValueUnitSelector,
  LabelValueUnitSelectorProps,
  UnitSelector2,
  UnitSelectorProps,
} from 'views/templates/module/unitSelector';
import { DateInput, DateInputProps } from 'views/mutual/dateInput';
import { formatPrice } from 'views/utils/converter';
import { SimpleTooltip } from 'views/mutual/tooltip';
import { IconSize, SvgIcon } from 'views/mutual/svgIcon';
import { findIcon, IconName } from 'utils/handleIcon';
import { Spinbox, SpinboxProps } from 'views/mutual/spinbox';

export type LeaseFundRequestInputProps = {
  interest: number | null;
  accruedInterest?: string | null;
  totalAmountRaw: number | null;
  unitSelectorProps: UnitSelectorProps;
  dateInputProps: DateInputProps;
};

export type OverseasRealEstateRequestInputProps = {
  interest: number | null;
  accruedInterest?: string | null;
  totalAmountRaw: number | null;
  dateInputProps: DateInputProps;

  labelValueUnitSelectionProps: LabelValueUnitSelectorProps;
  spinboxProps: SpinboxProps;
  showManualQuantity?: boolean;
};

export type RequestInputProps = {
  leaseFundProps?: LeaseFundRequestInputProps;
  overseasRealEstateProps?: OverseasRealEstateRequestInputProps;
};

export const RequestInput = ({leaseFundProps, overseasRealEstateProps}: RequestInputProps) => {
  const props = leaseFundProps ?? overseasRealEstateProps;
  if(props == null)return <></>

  return (
    <div className="requestInput">
      <div className="requestInput_header">申込金額</div>
      <div className="requestInput_body">
        {leaseFundProps && (
          <>
            <UnitSelector2 {...leaseFundProps.unitSelectorProps} />
            <div className="requestInput_body_input">
              <div className="requestInput_body_input_header">出資金額</div>
              <div className="requestInput_body_input_value">{leaseFundProps.unitSelectorProps.selectedOption}</div>
              <div className="requestInput_body_input_unit">円</div>
            </div>
          </>
        )}
        {overseasRealEstateProps && (
          <>
            <div className="overview_inputField">
              <span>{'申込金額：'}</span>
              <LabelValueUnitSelector {...overseasRealEstateProps.labelValueUnitSelectionProps} />
            </div>
            <div className="overview_inputField">
              {overseasRealEstateProps.showManualQuantity && (
                <>
                  <span>{'手入力（円）：'}</span>
                  <Spinbox {...overseasRealEstateProps.spinboxProps} unitPosition="right_6rem" />
                </>
              )}
            </div>
          </>
        )}
        <DateInput {...props.dateInputProps} />
        <Description
          label={
            <>
              ※振込が完了する日（期日）をご指定ください。
              <br />
              　指定された期日までに着金が確認できない場合は、ご出資いただけない可能性がございます。
            </>
          }
          labelColor={labelColor.red}
          labelSize={labelSize.small}
        />
        <div className="requestInput_body_interest">
          <div className='requestInput_body_interest_tooltip'>
            <span>{'経過利息'}</span>
            <SimpleTooltip triggerText={<SvgIcon icon={findIcon(IconName.help)} size={IconSize.icon_xs} />} description={props.accruedInterest ?? ''} />            
          </div>
          {formatPrice(props.interest)}
        </div>
        <span className="requestInput_body_total">{formatPrice(props.totalAmountRaw)}</span>
        <Description
          label="※申込金額は、10,000,000円単位でご入力ください。"
          labelColor={labelColor.gray}
          labelSize={labelSize.small}
        />
        <Description
          label="※経過利息及び譲渡代金総額は、振込予定日までにご入金いただく場合の金額を表示しています。"
          labelColor={labelColor.gray}
          labelSize={labelSize.small}
        />
        <Description
          label="※お申込日時点によって、選択できる振込予定日を制限させて頂いております。"
          labelColor={labelColor.gray}
          labelSize={labelSize.small}
        />
      </div>
    </div>
  );
};